//******************************************************************************
// 輝度を調整する関数
/*
// 使用例
const originalColor = { r: 100, g: 150, b: 200 }; // 元の色
const brightnessFactor = 0.2; // 20%の輝度を増加
const brighterColor = adjustBrightness( originalColor, brightnessFactor );
console.log(brighterColor); // { r: 120, g: 180, b: 240 }
*/

//******************************************************************************
/**
 * 引数（色）を整理する関数
 * @param {Array<number>|{r:number, g:number, b:number, a?:number}} values
 * @returns {Array<number>}
 * @throws {Error} 引数が想定外の場合に例外
*/
const optimize = (values) => {
	//--------------------------------------------------------------------------
	// 結果を格納する配列を用意
	const rgb = [];
	//--------------------------------------------------------------------------
	// 値が配列か否かで分岐
	if (Array.isArray(Array.from(values)) === true) {
		// 値が配列の場合はそのまま格納
		rgb.push(...values);
	} else if (typeof values === "object") {
		// 値がオブジェクトの場合
		// nullは例外
		if (values === null) {
			throw new Error("Invalid value specified.");
		}
		// rgb各要素が含まれていなければ例外
		["r", "g", "b"].forEach((value) => {
			if (typeof values[value] === "undefined") {
				throw new Error("Invalid value specified.");
			}
			// 結果配列に格納
			rgb.push(values[value]);
		});
	} else {
		// 上記以外は例外
		throw new Error("Invalid value specified.");
	}
	//--------------------------------------------------------------------------
	// 配列の要素数が3未満の場合は例外
	if (rgb.length < 3) {
		throw new Error("Invalid value specified.");
	}
	//--------------------------------------------------------------------------
	// 最初の3要素だけ返す
	return rgb.slice(0, 3);
};

//******************************************************************************
/**
 * export function
 * @param {Array<number>|{r:number, g:number, b:number, a?:number}} values
 * @param {number} factor
 * @returns {Array<number>}
*/
export function adjustBrightness(value, factor) {
	//--------------------------------------------------------------------------
	// 引数を整理する
	const [r, g, b] = optimize(value);
	//--------------------------------------------------------------------------
	// 輝度を調整する計算（各値に増加分を加算）
	const newR = Math.max(0, Math.min(255, r + Math.round(255 * factor)));
	const newG = Math.max(0, Math.min(255, g + Math.round(255 * factor)));
	const newB = Math.max(0, Math.min(255, b + Math.round(255 * factor)));
	//--------------------------------------------------------------------------
	// 結果を返す
	return [newR, newG, newB];
}
